import React from 'react';
import {
    Button,
    Label,
    ProgressBar,
    Text,
    tokens
} from '@fluentui/react-components';
import {
    DocumentAdd24Regular,
    Delete24Regular,
    CheckmarkCircle24Regular,
    ErrorCircle24Regular,
    Clock24Regular
} from '@fluentui/react-icons';

import { TFunction } from 'i18next';
import { Separator } from '@fluentui/react';

interface SelectedFilesSectionProps {
    selectedFiles: File[];
    uploadProgress: { [key: string]: number };
    isUploading: boolean;
    handleRemoveFile: (index: number) => void;
    t: TFunction;
    fileStatus?: { [fileName: string]: 'pending' | 'success' | 'error' };
}

const getFileKey = (file: File): string => `${file.name}-${file.size}-${file.lastModified}`;

export const SelectedFilesSection: React.FC<SelectedFilesSectionProps> = ({
    selectedFiles,
    uploadProgress,
    isUploading,
    handleRemoveFile,
    t,
    fileStatus = {}
}) => (
    <div className="selected-files">
        <Label>{t('fileUpload.selectedFiles')}</Label>
        {selectedFiles.map((file: File, index: number) => {
            const fileKey = getFileKey(file);
            const status = fileStatus[fileKey];
            let statusIcon = null;
            if (status === 'success') {
                statusIcon = <CheckmarkCircle24Regular style={{ color: tokens.colorStatusSuccessForeground1 }} title={t('fileUpload.uploadSuccess')} />;
            } else if (status === 'error') {
                statusIcon = <ErrorCircle24Regular style={{ color: tokens.colorStatusDangerForeground1 }} title={t('fileUpload.uploadError')} />;
            } else if (status === 'pending') {
                statusIcon = <Clock24Regular style={{ color: tokens.colorBrandForeground1 }} title={t('fileUpload.uploading')} />;
            }
            return (
                <div key={fileKey} className="file-item">
                    <div className="file-info">
                        <DocumentAdd24Regular />
                        <div className="file-details">
                            <Text weight="semibold">{file.name}</Text>
                            <Text size={200}>
                                {(file.size / 1024 / 1024).toFixed(2)} MB
                            </Text>
                        </div>
                    </div>
                    {uploadProgress[fileKey] !== undefined && (
                        <ProgressBar
                            value={uploadProgress[fileKey]}
                            max={100}
                            className="upload-progress"
                        />
                    )}
                    {/* Status icon and text */}
                    {status && (
                        <span className="file-upload-status" style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                            {statusIcon}
                            {/* <Text size={200} style={{ marginLeft: 4 }}>{statusText}</Text> */}
                        </span>
                    )}
                    <Button
                        appearance="subtle"
                        icon={<Delete24Regular />}
                        onClick={() => handleRemoveFile(index)}
                        disabled={isUploading}
                        aria-label={t('fileUpload.removeFile')}
                    />
                </div>
            );
        })}
    </div>
);
